export default __webpack_public_path__ + "static/media/levels.a05d7243.gif";